$(document).ready(function(){
    $('.block__video-reviews-ig-wrapper').slick({
        centerMode: true,
        centerPadding: '120px',
        slidesToShow: 3,
        nextArrow: '.block__video-reviews-ig-arrow-next',
        prevArrow: '.block__video-reviews-ig-arrow-prev',
        responsive: [
             {
                breakpoint: 1300,
                settings: {
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 3
                }
            },
             {
                breakpoint: 1024,
                settings: {
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerMode: true,
                    centerPadding: '20px',
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 480,
                settings: {
                    centerMode: true,
                    centerPadding: '0px',
                    slidesToShow: 1
                }
            }
        ]
    });
}); 

$('.block__video-reviews-ig-upper').on('click', function () {
  const $container = $(this);
  const $popup = $('.block__video-reviews-ig-popup');
  const $videoEl = $('.block__video-reviews-ig-popup-video');

  const videoSrc = $container.find('.block__video-reviews-ig-image').data('src');

  if (videoSrc && $videoEl.length) {
    const video = $videoEl.get(0);

    $videoEl.find('source').attr('src', videoSrc);

    video.load();
    video.play();
    $popup.show();
  }
});
$('.block__video-reviews-ig-popup-close').on('click', function () {
    const $popup = $('.block__video-reviews-ig-popup');
    const $videoEl = $('.block__video-reviews-ig-popup-video');
    const video = $videoEl.get(0);
    video.pause();
    $popup.hide();
});
$('.block__video-reviews-ig-popup').on('click', function (e) {
    if ($(e.target).closest('.block__video-reviews-ig-popup-inner:hover').length === 0) {
        const $popup = $('.block__video-reviews-ig-popup');
        const $videoEl = $('.block__video-reviews-ig-popup-video');
        const video = $videoEl.get(0);
        video.pause();
        $popup.hide();
    }
});